import { gtag } from "@c15t/scripts/google-tag";
import { googleTagManager } from "@c15t/scripts/google-tag-manager";
import { metaPixel } from "@c15t/scripts/meta-pixel";
import type { Script } from "c15t";
import { env } from "~/lib/env/client";

const GTM_ID = env.VITE_GTM_ID ?? "GTM-5GR2RKXC";
const GA_ID = env.VITE_GA_ID ?? "G-N9HS13X3HN";

export function buildConsentScripts(): Script[] {
  const scripts: Script[] = [
    googleTagManager({ id: GTM_ID }),
    gtag({ category: "measurement", id: GA_ID }),
  ];

  if (env.VITE_META_PIXEL_ID) {
    scripts.push(metaPixel({ pixelId: env.VITE_META_PIXEL_ID }));
  }

  return scripts;
}
